import { createAsyncActionType } from './types';

export const GET_ALL_CERTIFICATION_LIGHT_HOUSE = createAsyncActionType(
  'CAR_LIST',
  'GET_ALL_CERTIFICATION_LIGHT_HOUSE',
);
export const GET_ALL_MODEL_CAR = createAsyncActionType(
  'CAR_LIST',
  'GET_ALL_MODEL_CAR',
);
export const GET_ALL_COLOR_EXT_CAR = createAsyncActionType(
  'CAR_LIST',
  'GET_ALL_COLOR_EXT_CAR',
);
export const GET_ALL_COLOR_INT_CAR = createAsyncActionType(
  'CAR_LIST',
  'GET_ALL_COLOR_INT_CAR',
);
